'use client';

import { HomeFloatingButton } from '@/app/(home)/components/topArea/floatingButton/FloatingButton';
import { useEffect, useRef, useState } from 'react';

export const SaleFloatingButton = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const isScrolledRef = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 0;
      if (scrolled !== isScrolledRef.current) {
        isScrolledRef.current = scrolled;
        setIsScrolled(scrolled);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <HomeFloatingButton
      isShow={isScrolled}
      offset={{ bottom: 32, right: 32 }}
    />
  );
};
